module.exports = __webpack_public_path__ + "static/media/nb.5fc94e90.svg";